import React from 'react';
import R from 'ramda';
import IconButton from '@cotyorg/ccx-molecules/IconButton';
import PropTypes from 'prop-types';

const LookDescription = ({ shadeList, setLookDescriptionOpen }) => (
  <div className="vto__product-details-look-description">
    <ul className="vto__product-details-look-description-list">
      {shadeList.map((shade, id) => (
        <li key={id} className="vto__product-details-look-description-item">
          {R.prop('name', shade)}
        </li>
      ))}
    </ul>

    <IconButton
      size="small"
      iconSrc="/ccx-files/assets/cross.svg"
      extraClass="vto__product-details-look-description-close"
      onClick={() => setLookDescriptionOpen(false)}
    />
  </div>
);

LookDescription.propTypes = {
  shadeList: PropTypes.array,
  setLookDescriptionOpen: PropTypes.func,
};

export default LookDescription;
